export default {
  production: '6596babcc144a8a576f0504f',
  development: '66cc7065f350e9752931cff7',
  test: '66cc7065f350e9752931cff7',
};
